const actions = {
  REQUESTING: 'WorkOrderCustomerStatuss/REQUESTING',
  RESPONSE_ERROR: 'WorkOrderCustomerStatuss/RESPONSE_ERROR',

  FETCH_WORKORDERCUSTOMERSTATUSS: 'WorkOrderCustomerStatuss/FETCH',
  LIST_WORKORDERCUSTOMERSTATUS: 'WorkOrderCustomerStatus/LIST',

  FETCH_WORKORDERCUSTOMERSTATUS: 'WorkOrderCustomerStatus/FETCH',
  NEW_WORKORDERCUSTOMERSTATUS: 'WorkOrderCustomerStatus/NEW',
  EDIT_WORKORDERCUSTOMERSTATUS: 'WorkOrderCustomerStatus/EDIT',
  RESET_WORKORDERCUSTOMERSTATUS: 'WorkOrderCustomerStatus/RESET',

  RE_FETCH_WORKORDERCUSTOMERSTATUSS: 'WorkOrderCustomerStatuss/REFRESH',
  SAVE_WORKORDERCUSTOMERSTATUS: 'WorkOrderCustomerStatus/SAVE',
  SAVE_WORKORDERCUSTOMERSTATUS_RECIEVED:
    'WorkOrderCustomerStatus/SAVE_WORKORDERCUSTOMERSTATUS_RECIEVED',

  DELETE_WORKORDERCUSTOMERSTATUS: 'WorkOrderCustomerStatus/DELETE',
  DELETE_WORKORDERCUSTOMERSTATUS_RECIEVED: 'WorkOrderCustomerStatus/DELETE_RECIEVED',
}

export default actions
